import { render, staticRenderFns } from "./ElectionDetail.vue?vue&type=template&id=df33978e"
import script from "./ElectionDetail.vue?vue&type=script&lang=js"
export * from "./ElectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports